import {useFormContext} from "react-hook-form";
import {FormControl, FormField, FormItem, FormLabel} from "@/components/ui/form.tsx";
import {CharacterSizeOptions} from "@/characters/model/CharacterSizes.ts";
import {Switch} from "@/components/ui/switch.tsx";
import {Alignments} from "@/characters/model/Alignments.ts";
import {Character} from "@/characters/model/Character.ts";
import {isBlank} from "@/util/isBlank.ts";
import TextInputField from "@/components/forms/TextInputField.tsx";
import SelectInputField from "@/components/forms/SelectInputField.tsx";
import ImageUploadField from "@/images/ImageUploadField.tsx";
import {Image} from "@/images/Image.ts";
import FormSection from "@/components/forms/FormSection.tsx";
import CharacterProfileForm from "@/characters/admin/form/CharacterProfileForm.tsx";

export default function CharacterBasicsForm({character, image, uploadingImage, onImageSelected}: {
    character?: Character;
    image?: Image;
    uploadingImage: boolean;
    onImageSelected: (file: File) => void;
}) {
    const {control} = useFormContext();

    return <div className="grid gap-8 xl:grid-cols-[minmax(0,2fr)_minmax(16rem,1fr)]">
        <div className="space-y-8">
            <FormSection title="Stammdaten">
                <div className="grid content-start gap-4 md:grid-cols-2">
                    <TextInputField name="name" title="Name" placeholder="Charaktername"/>
                    <TextInputField name="id" title="ID" placeholder="Eindeutige ID"
                                    disabled={!isBlank(character?.id)}/>
                    <SelectInputField name="size" title="Größe" options={CharacterSizeOptions()}/>
                    <SelectInputField name="alignment" title="Gesinnung" options={Alignments} nullable/>
                    <TextInputField name="source" title="Quelle" placeholder="Monsterhandbuch, …"/>
                    <FormField control={control} name="hostile" render={({field}) => (
                        <FormItem>
                            <FormLabel>Beziehung</FormLabel>
                            <div className="flex h-9 items-center gap-3 rounded-md border px-3">
                                <FormControl>
                                    <Switch checked={field.value} onCheckedChange={field.onChange}/>
                                </FormControl>
                                <span className="text-sm">{field.value ? "Feindlich" : "Verbündet"}</span>
                            </div>
                        </FormItem>
                    )}/>
                </div>
            </FormSection>
            <CharacterProfileForm/>
        </div>
        <aside className="self-start xl:sticky xl:top-0">
            <h2 className="mb-3 border-b pb-3 font-semibold">Portrait</h2>
            <ImageUploadField image={image}
                              uploading={uploadingImage}
                              onFileSelected={onImageSelected}
                              alt="Charakterbild"
                              className="min-h-64 rounded-lg border"/>
        </aside>
    </div>;
}
